var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.treeDataEdit')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.openTreeDataEdit
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.editAction')))]), _vm._v(" "), (_vm.dataDialogVisible) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "modal-append-to-body": false,
      "title": _vm.i18nt('designer.setting.treeDataEdit'),
      "visible": _vm.dataDialogVisible,
      "show-close": true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true,
      "width": "75%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dataDialogVisible = $event
      }
    }
  }, [_c('code-editor', {
    attrs: {
      "mode": 'json',
      "readonly": false
    },
    model: {
      value: (_vm.treeDataOptions),
      callback: function($$v) {
        _vm.treeDataOptions = $$v
      },
      expression: "treeDataOptions"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.saveTreeData
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.confirm')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "large",
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.dataDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.cancel')))])], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ba2332","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-tree/treeData-editor.vue
// module id = null
// module chunks = 